import React from 'react';
import Icon from './Icon';

export default function IconButton({ icon, label, className = '', ...props }) {
  return (
    <button
      aria-label={label}
      className={`pl-button pl-button--icon ${className}`.trim()}
      title={label}
      type="button"
      {...props}
    >
      <Icon name={icon} size={20} />
    </button>
  );
}
